import Backbone from '../../../../../../../node_modules/backbone/backbone.js';
import _ from 'underscore';

'use strict';

// Compatibility override - Backbone 1.1 got rid of the automatic 'options' binding
// on Views - we need to keep that.
Backbone.View = (function (View) {
	return View.extend({
		constructor: function (options) {
			this.options = options || {};
			View.apply(this, arguments);
		}
	});
})(Backbone.View);

Backbone.Collection = (function (Collection) {
	return Collection.extend({
		fetch: function (options) {
			return Collection.prototype.fetch.call(this, _.extend(options, { reset: true }));
		}
	});
})(Backbone.Collection);

Backbone.syncWithJSON = function (method, model, options) {
	Backbone.sync.call(this, method, model, _.extend(options, { emulateJSON: false }));
};

export default Backbone;



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/config/backbone.js